import cn from 'classnames';
import { Stub, type StubProps } from '@direct-frontend/components';
import { makeModifierClassname } from '../../../../lib/makeModifierClassname';
import styles from './DrawerButton.module.css';

const buttonModifier = makeModifierClassname(styles, 'button');

export const DrawerButtonStub = ({ height }: Pick<StubProps, 'height'>) => (
    <div style={{ height }} className={cn(buttonModifier.className, buttonModifier('stub', true))}>
        <Stub height={height} width="100%" />
    </div>
);
